export default __webpack_public_path__ + "static/media/blob_03.4da33b8d.mp4";